<template>
  <!-- 我的资源包详情 -->
  <div class="myspecialDetail">
    <div class="myspecialDetail1">
      <p class="ellipsis-aRow">{{ formdata.name }}</p>
      <div class="myspecialDetail1_fix">共{{ total }}个资源</div>
      <span v-if="source != 'order'"
        >来源：{{
          formdata.sourceName === "distribute"
            ? formdata.sourceDeptName
            : callDictionaries(acquireSourcelist, formdata.sourceName)
        }}</span
      >
    </div>
    <div class="myspecialDetail2">
      <div class="mydetail_title">
        <p>商品列表</p>
      </div>
      <div class="myspecialDetail2_box">
        <li v-for="(item, index) in tabledata" :key="index">
          <el-image
            @click="toDetail(item)"
            class="myspecialDetail2_img"
            :src="item.cover"
            fit="contain"
          ></el-image>
          <div class="myResources2_b">
            <span v-if="item.sourceFile">{{ item.sourceFile }}</span>
            <p
              @click="toDetail(item)"
              class="ellipsis-aRow"
              :title="item.goodsTitle"
            >
              {{ item.goodsTitle }}
            </p>
          </div>
        </li>
      </div>
      <noData v-show="!tabledata.length"></noData>
      <div class="myResources3">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[12, 24, 36, 48, 60]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  selectBundleBase,
  selectBundleGoodsList,
  selectResourceBundleDetail,
} from "@/api/special/special";
import {
  teachingAttrList, //字典值
  goodsInfoDetail,
} from "@/api/bookstore/bookstore";
import noData from "@/components/noData.vue";
export default {
  data() {
    return {
      //查询参数
      id: undefined,
      queryParams: {
        pageNum: 1,
        pageSize: 12,
      },
      formdata: {},
      tabledata: [],
      total: 0,
      acquireSourcelist: [], //来源字典
      source: "",
    };
  },
  components: { noData },
  created() {
    this.id = this.$route.query.subjectId;
    this.getselectBundleBase();
    this.getresource_source();
  },
  watch: {
    //监听路由变化
    $route() {
      console.log(this.$route.path);
      if (this.$route.path === "/user/myresourcesDetail") {
        if (this.$route.query.subjectId) {
          this.id = this.$route.query.subjectId;
          this.getselectBundleBase();
        }
      }
    },
  },
  methods: {
    getselectBundleBase() {
      if (this.$route.query.type == "order") {
        this.source = "order";
        //判断是否是从订单详情跳转过来的，订单详情直接穿过来的资源id
        var newqueryParams = JSON.parse(JSON.stringify(this.queryParams));
        newqueryParams.id = this.id;
        selectBundleGoodsList(newqueryParams).then((res2) => {
          if (res2.code == 200) {
            this.tabledata = res2.rows;
            this.total = res2.total;
          }
        });
      } else {
        this.source = "";
        selectBundleBase({ id: this.id }).then((res) => {
          if (res.code == 200) {
            this.formdata = res.data;
            var newqueryParams = JSON.parse(JSON.stringify(this.queryParams));
            newqueryParams.id = res.data.id;
            console.log(newqueryParams);
            selectBundleGoodsList(newqueryParams).then((res2) => {
              if (res.code == 200) {
                this.tabledata = res2.rows;
                this.total = res2.total;
              }
            });
          }
        });
      }
    },
    getresource_source() {
      //来源的字典
      teachingAttrList("resource_source").then((res) => {
        this.acquireSourcelist = res.data;
      });
    },
    toDetail(item) {
      if (item.goodsType == "paper") {
        //判断题组类型
        goodsInfoDetail(item.goodsId).then((res) => {
          if (res.code == 200) {
            if (res.data.sourceList.length > 0) {
              if (res.data.sourceList[0].resourceType == "bank") {
                let url = this.$router.resolve({
                  path: "/bookstore/bookstoreDetail",
                  query: {
                    goodsId: item.goodsId,
                    goodsType: item.goodsType,
                  },
                });
                window.open(url.href, "_blank");
              } else {
                let url = this.$router.resolve({
                  path: "/bookstore/answer",
                  query: {
                    goodsId: item.goodsId,
                    relevanceId: this.$route.query.relevanceId, //业务id
                    resource: this.formdata.sourceName, //来源
                    resourceType: this.$route.query.resourceType,
                    teachInstId: this.$route.query.teachInstId,
                    typeName: "0", //判断是否能加入书架
                  },
                });
                window.open(url.href, "_blank");
              }
            }
          }
        });
      } else if (item.goodsType == "train") {
        let url = this.$router.resolve({
          path: "/willingLearn/courseQuestions",
          query: {
            goodsId: item.goodsId,
          },
        });
        window.open(url.href, "_blank");
      } else {
        let url = this.$router.resolve({
          path: "/onlineReading",
          query: {
            goodsId: item.goodsId,
            relevanceId: this.$route.query.relevanceId, //业务id
            resource: this.formdata.sourceName, //来源
            resourceType: this.$route.query.resourceType,
            teachInstId: this.$route.query.teachInstId,
            typeName: "0", //判断是否能加入书架
          },
        });
        window.open(url.href, "_blank");
      }
    },
    //每页条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getselectBundleBase();
    },
    //当前页面
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getselectBundleBase();
    },
  },
};
</script>

<style scoped>
.myspecialDetail {
  width: 1400px;
  margin: 0 auto;
  overflow: hidden;
}
.myspecialDetail1 {
  width: 100%;
  float: left;
  background: #fffefd;
  padding: 40px;
  box-sizing: border-box;
}
.myspecialDetail1 p {
  font-size: 16px;
  margin-bottom: 23px;
  width: calc(100% - 200px);
  float: left;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.myspecialDetail1 > span {
  font-size: 14px;
  width: 100%;
  float: left;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}
.myspecialDetail1_fix {
  font-size: 14px;
  padding: 7px 11px;
  float: right;
  font-family: PingFang SC;
  font-weight: 400;
  color: #0081ce;
  line-height: 9px;
  background: #ffffff;
  border: 1px solid #0081ce;
  border-radius: 6px;
}
.myspecialDetail2 {
  width: 100%;
  float: left;
  background: #fffefd;
  min-height: 100px;
  margin-top: 16px;
  margin-bottom: 40px;
}
.mydetail_title {
  width: 100%;
  float: left;
  border-bottom: 1px solid #f2f2f2;
  height: 52px;
  line-height: 52px;
}
.mydetail_title p {
  font-size: 16px;
  line-height: 52px;
  margin-left: 30px;
  border-bottom: 2px solid #2e9adb;
  float: left;
  padding: 0 8px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #2e9adb;
}
.myspecialDetail2_box {
  width: 100%;
  float: left;
  padding: 30px 40px;
  box-sizing: border-box;
}
.myspecialDetail2_box li {
  width: 170px;
  height: 214px;
  float: left;
  list-style: none;
  margin-right: 60px;
  margin-bottom: 30px;
}
.myspecialDetail2_box li:nth-child(6n) {
  margin-right: 0;
}
.myResources2_b {
  cursor: pointer;
  width: 100%;
  float: left;
}
.myResources2_b span {
  float: left;
  margin-right: 7px;
  padding: 0 10px;
  height: 24px;
  background: #f9fdff;
  border: 1px solid #0081ce;
  border-radius: 6px;
  font-size: 13px;
  line-height: 24px;
  text-align: center;
  font-family: PingFang SC;
  font-weight: 400;
  color: #0081ce;
}
.myResources2_b p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}
.myspecialDetail2_img {
  width: 170px;
  height: 170px;
  border-radius: 5px;
  margin-bottom: 18px;
  box-shadow: 0 0 3px #ccc;
}
.index_con_box1lbcon_tag {
  width: 100%;
  float: left;
  margin-bottom: 23px;
}
.index_con_box1lbcon_tag .el-tag {
  height: 28px;
  line-height: 28px;
  float: left;
  margin-right: 16px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  background: #f2f2f2;
  border-radius: 6px;
}
.myResources3 {
  float: right;
  margin: 20px;
}
</style>
